import { useReadContracts } from "wagmi";
import useDappConfig from "./useDappConfig";
import { formatUnits } from "viem";
import { ETH, SFRXETH, TokenDetails } from "@config/contractsConfig";

const useInstantWithdrawalAvailability = () => {
  const { config } = useDappConfig();

  const tokensObj = {
    ...config.tokens,
    [ETH]: config.nativeToken as any,
  } as TokenDetails;

  const tokens = Object.keys(tokensObj)
    .filter((token) => tokensObj[token].symbol !== SFRXETH)
    .map((token) => tokensObj[token]);

  const { data: availableAmounts, refetch: refetchAvailableAmounts } =
    useReadContracts({
      contracts: tokens.map((token) => ({
        ...config.interactionPools?.lrtUnstakingVault,
        functionName: "getAssetsAvailableForInstantWithdrawal",
        args: [token.address],
      })),
      query: {
        enabled: !!tokens.length,
        refetchInterval: 10_000,
      },
    });

  const instantWithdrawalAvailable: { [x: string]: number } = availableAmounts
    ? tokens.reduce((acc, curr, index) => {
        return {
          ...acc,
          [curr.symbol]: Math.max(
            Number(
              availableAmounts[index].result
                ? formatUnits(availableAmounts[index].result as bigint, 18)
                : 0n
            ),
            0
          ),
        };
      }, {})
    : {};

  return {
    instantWithdrawalAvailable,
    refetchAvailableAmounts,
  };
};

export default useInstantWithdrawalAvailability;
